// src/services/authService.js
import axios from "axios";

// Normaliza la base para evitar // o /api/api
const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
const API_URL = `${API_BASE}/api/auth`;

/**
 * Inicia sesión.
 * - POST /api/auth/login { clave, password }
 * - Si el backend regresa token/user/empresaId, los guardamos (opcional).
 * - Ajusta al shape real de tu respuesta si difiere.
 */
export async function verificarCredenciales(clave, password, empresaId) {
  try {
    const resp = await axios.post(`${API_URL}/login`, { clave, password, empresaId });

    const data = resp?.data ?? {};
    // si tu backend devuelve algo como { token, user, empresaId }
    if (data.token) {
      setSession(data.token);
    }
    if (data.user) {
      try { localStorage.setItem("user", JSON.stringify(data.user)); } catch {}
      const emp =
        data.user?.empresaId ??
        data.user?.EmpresaId ??
        data.empresaId ??
        null;
      if (emp != null) localStorage.setItem("empresaId", String(emp));
    } else if (data.empresaId != null) {
      localStorage.setItem("empresaId", String(data.empresaId));
    }

    return resp; // deja tu contrato igual (retorna response)
  } catch (error) {
    console.error("Error en la autenticación:", error);
    throw error;
  }
}

/** Coloca/limpia el Authorization global de axios y guarda el token. */
export function setSession(token) {
  if (token) {
    localStorage.setItem("authToken", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("authToken");
    delete axios.defaults.headers.common["Authorization"];
  }
}

/** Útil al arrancar la app (por ejemplo en index.js o App.js). */
export function initAuthFromStorage() {
  const token = localStorage.getItem("authToken");
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }

  // Interceptor global: si el servidor devuelve 401 en cualquier llamada
  // protegida, cerrar sesión y redirigir al login con un aviso.
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url ?? "";
      const isLoginEndpoint = url.includes("/api/auth/login");

      if (status === 401 && !isLoginEndpoint) {
        logout();
        sessionStorage.setItem("loginNotice", "Tu sesión ha expirado. Por favor inicia sesión nuevamente.");
        window.location.replace("/login");
      }

      return Promise.reject(error);
    }
  );
}

/** Cerrar sesión: limpia storage y headers. */
export function logout() {
  try {
    // si tu backend tiene endpoint para cerrar cookie de sesión:
    // await axios.post(`${API_URL}/logout`).catch(() => {});

    ["authToken", "token", "user", "empresaId"].forEach((k) =>
      localStorage.removeItem(k)
    );
    sessionStorage.clear?.();
    delete axios.defaults.headers.common["Authorization"];
  } catch {
    // noop
  }
}

/** Helper por si te sirve centralizado */
export function getEmpresaId() {
  const n = parseInt(localStorage.getItem("empresaId") || "", 10);
  if (Number.isFinite(n) && n > 0) return n;
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    const fromUser = parseInt(user?.empresaId ?? user?.EmpresaId ?? "", 10);
    if (Number.isFinite(fromUser) && fromUser > 0) return fromUser;
  } catch {}
  return null;
}
